module.exports = __webpack_public_path__ + "img/logo_NTT-DATA-GSL.7229ead8.svg";